<template>
    <BasePage :loading="loading" :error="error" :params="params">
        <SotHeader v-if="params && !params.hide_header" :params="params" />
        <div class="column q-gutter-y-sm no-wrap base-page-content" @scroll="onScroll">
            <div v-for="module in modules" :key="module.id">
                <SotButton :label="module.title" @click="openModule(module)" :params="{}" style="padding: 0 10px 0 20px" class="full-width" />
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import SotHeader from 'components/ui/design/SotHeader';
import pageScrollSaver from 'src/mixins/pageScrollSaverMixin';
import { queryBot } from 'boot/axios';
import SotButton from 'components/ui/design/SotButton';

export default {
    name: 'PageModules',
    components: { SotButton, SotHeader, BasePage },
    mixins: [pageScrollSaver],
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    mounted () {
        this.init();
    },
    data () {
        return {
            loading: false,
            error: undefined,
            modules: undefined,
            courseId: undefined,
        };
    },
    methods: {
        async init () {
            this.loading = true;
            this.courseId = this.params.course_id;
            await queryBot(`select * from modules where course_id = ${this.courseId} order by pos_index`).then((r) => {
                this.modules = [].concat(r.data);
            });
            this.loading = false;
        },
        openModule (module) {
            const payload = { to: 'tasks', ...this.params };
            payload.title = module.title;
            payload.hide_header = false;
            payload.module_id = module.id;
            this.$pages.push(payload);
        },
    },
};
</script>

<style scoped>

</style>
